export const AVATARS = [
  { bg: "#fce7f3", color: "#db2777" },
  { bg: "#e0f2fe", color: "#0284c7" },
  { bg: "#fef3c7", color: "#d97706" },
  { bg: "#d1fae5", color: "#059669" },
  { bg: "#e0e7ff", color: "#4f46e5" },
];

export const BOARD = [
  {
    name: "Prospecting",
    color: "#8B5CF6",
    cards: [
      { co: "Savanna Logistics", person: "Amina Otieno", phone: "+254 712 000 111", industry: "Logistics", action: "Verify", rep: "SR", ago: "Today" },
      { co: "Lakeview Hotels", person: "Brian Mwangi", phone: "+254 733 000 222", industry: "Hospitality", action: "Verify", rep: "JK", ago: "Today" },
      { co: "Tana Agro Supplies", person: "Faith Chebet", phone: "+254 728 000 909", industry: "Agriculture", action: "Verify", rep: "SR", ago: "1d ago" },
    ],
  },
  {
    name: "Lead Qualification",
    color: "#EC4899",
    cards: [
      { co: "Nairobi Tech Hub", person: "Grace Wanjiru", phone: "+254 722 000 333", industry: "Technology", action: "Move", warn: "No activity for 3+ days", rep: "MN", ago: "4d ago" },
      { co: "Mara Insurance", person: "Peter Kamau", phone: "+254 701 000 444", industry: "Insurance", action: "Move", rep: "JK", ago: "Yesterday" },
    ],
  },
  {
    name: "Discovery/Pain Points",
    color: "#F59E0B",
    cards: [
      { co: "Rift Valley Dairies", person: "Lucy Achieng", phone: "+254 745 000 555", industry: "Agriculture", action: "Move", deals: "1 deal · KSh 320,000", rep: "SR", ago: "2h ago" },
      { co: "Eldoret Motors", person: "Samuel Rono", phone: "+254 735 000 121", industry: "Automotive", action: "Move", deals: "1 deal · KSh 180,000", rep: "MN", ago: "Yesterday" },
    ],
  },
  {
    name: "Demo/Pitch",
    color: "#10B981",
    cards: [
      { co: "Coastal Freight Ltd", person: "Hassan Ali", phone: "+254 716 000 666", industry: "Shipping", action: "Move", deals: "2 deals · KSh 450,000", rep: "JK", ago: "1h ago" },
      { co: "Kilimani Clinics", person: "Joy Njeri", phone: "+254 799 000 777", industry: "Healthcare", action: "Move", deals: "1 deal · KSh 275,000", rep: "SR", ago: "Today" },
    ],
  },
  {
    name: "Proposal",
    color: "#3B82F6",
    cards: [
      { co: "Summit Education", person: "David Kiptoo", phone: "+254 710 000 888", industry: "Education", action: "Move", deals: "1 deal · KSh 640,000", rep: "MN", ago: "Today" },
      { co: "Kisumu Fresh Foods", person: "Akinyi Odhiambo", phone: "+254 724 000 515", industry: "Food & Beverage", action: "Move", deals: "1 deal · KSh 210,000", rep: "JK", ago: "2d ago" },
    ],
  },
  {
    name: "Negotiation",
    color: "#6366F1",
    cards: [
      { co: "Westlands Realty", person: "Mercy Wambui", phone: "+254 702 000 313", industry: "Real Estate", action: "Move", deals: "1 deal · KSh 880,000", rep: "SR", ago: "3h ago" },
    ],
  },
];

export const WAVE = [40, 70, 50, 90, 60, 100, 45, 80, 55, 95, 35, 75, 60, 85, 50, 70, 40, 65, 55, 90, 45, 70];